import { debounce } from 'lodash'
import { useRef } from 'react';

export default function useDebounce(callBack: (e : React.ChangeEvent<HTMLInputElement> ) => void, delay: number, options: {}) {
    return useRef(debounce(callBack, delay, options)).current
}
